import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import CustomTable from "../../Components/CustomTable";
import { useDispatch } from "react-redux";
import {
  resultList,
  approveRejectResult,
  allowEditResult,
} from "../../Redux/Slices/resultSlice";
import {
  getVillageList,
  getEducationList,
  resultExport,
} from "../../Redux/Slices/userAnalyticsSlice";
import toast from "react-hot-toast";
import RejectModal from "../../Components/RejectModal";
import ConfirmModal from "../../Components/ConfirmModal";

const ResultNotification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [notificationType, setNotificationType] = useState(location.state?.notificationType || "pending");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [paginationState, setPaginationState] = useState({
    page: 1,
    limit: 10,
  });

  const [SelectedVillage, setSelectedVillage] = useState(null);
  const [SelectedEducation, setSelectedEducation] = useState(null);
  const [paginationData, setPaginationData] = useState([]);
  const [villages, setVillages] = useState([]);
  const [educations, setEducations] = useState([]);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [villageSearch, setVillageSearch] = useState("");
  const [educationSearch, setEducationSearch] = useState("");
  const [confirmConfig, setConfirmConfig] = useState({
    title: "",
    message: "",
    onConfirm: () => { },
  });
  const [rejectId, setRejectId] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [isAllowEditRequest, setIsAllowEditRequest] = useState(false);

  // const [selectedFilters, setSelectedFilters] = useState({
  //     dateRange: '',
  //     status: '',
  //     category: '',
  //     type: ''
  // });

  const getVillage = async (search = "") => {
    try {
      const response = await dispatch(getVillageList({ search })).unwrap();
      if (response.IsSuccess) {
        setVillages(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Villages");
    }
  };
  const getEducation = async (search = "") => {
    try {
      const response = await dispatch(getEducationList({ search })).unwrap();
      if (response.IsSuccess) {
        const filteredEducations = (response.Data || []).filter(item => item.isresult);
        setEducations(filteredEducations);
      }
    } catch (error) {
      toast.error("Failed to fetch Education");
    }
  };

  const getResultListFun = async () => {
    try {
      setLoading(true);
      const payload = {
        page: paginationState.page,
        limit: paginationState.limit,
        search: searchValue || "",
        action: notificationType || "",
        village: SelectedVillage || "",
        education: SelectedEducation || "",
        series: selectedSeries || "",
      };
      const response = await dispatch(resultList(payload)).unwrap();
      setTableData(response.Data.docs);
      setPaginationData(response.Data.totalDocs);
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (page, limit) => {
    setLoading(true);
    try {
      const payload = {
        page: page || 1,
        limit: limit || 10,
        search: searchValue || "",
        action: notificationType || "",
        village: SelectedVillage || "",
        education: SelectedEducation || "",
        series: selectedSeries || "",
      };
      setPaginationState({ page: page, limit: limit });
      const response = await dispatch(resultList(payload)).unwrap();
      setTableData(response.Data.docs);
      setPaginationData(response.Data.totalDocs);
      setLoading(false);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const handleClearFilter = () => {
    setSelectedEducation("");
    setSelectedVillage("");
    setSearchValue("");
    setSelectedSeries("");
    setVillageSearch("");
    setEducationSearch("");
  };

  //   const handleStatusChange = async (id, currentStatus) => {
  //     try {
  //       setLoading(true);
  //       await dispatch(
  //         approveRejectResult({
  //           resultId: id || "",
  //           action: currentStatus ? "rejected" : "approved",
  //         }),
  //       ).unwrap();
  //       await getResultListFun();
  //       toast.success("Status updated successfully");
  //       setLoading(false);
  //     } catch (error) {
  //       setLoading(false);
  //       console.log("error :>> ", error);
  //       toast.error("Failed to update status");
  //     }
  //   };

  const columns = [
    (notificationType === "approved" || notificationType === "distributed") && {
      key: "couponCode",
      label: "Coupon Code",
      renderCell: (key, row) => row?.couponCode || "-",
    },
    {
      key: "name",
      label: "User Name",
      renderCell: (key, row) => (
        <div onClick={() => handleEditNotification(row)}>
          <span className="hover:text-primary hover:font-semibold cursor-pointer" title="View Details">
            {row?.familymember?.name} {row?.familymember?.surname}
          </span>
        </div>
      ),
    },
    {
      key: "mobile",
      label: "Mobile No",
      renderCell: (key, row) => row?.user?.mobile || "-",
    },
    {
      key: "village",
      label: "Village",
      renderCell: (key, row) => row.village?.gujarati_name || "-",
    },
    {
      key: "medium",
      label: "Medium",
      renderCell: (key, row) => row.medium || "-",
    },
    // {
    //     key: "totalMarks",
    //     label: "Total Marks",
    //     renderCell: (key, row) => row.totalMarks || 'N/A'
    // },
    // {
    //     key: "obtainedMarks",
    //     label: "Obtained Marks",
    //     renderCell: (key, row) => row.obtainedMarks || 'N/A'
    // },
    {
      key: "percentage",
      label: "Percentage",
      renderCell: (key, row) => row.percentage || "-",
    },
    {
      key: "education",
      label: "Education",
      renderCell: (key, row) => row.education?.gujarati_name || "-",
    },
    notificationType === "rejected" && {
      key: "remark",
      label: "Remark",
      renderCell: (key, row) => {
        const remark = row?.remark || "-";
        return (
          <span
            className="cursor-help border-gray-500 hover:text-primary transition-colors"
            title={remark}
          >
            {remark.length > 15 ? `${remark.substring(0, 15)}...` : remark}
          </span>
        );
      },
    },
    notificationType !== "distributed" && {
      key: "action",
      label: "Action",
      renderCell: (key, row) => {
        return (
          <div className="flex items-center justify-center gap-2">
            {notificationType === "pending" && (
              <>
                <button
                  className="flex items-center cursor-pointer space-x-2.5"
                  onClick={() => acceptRequest(row?._id)}
                  title="Accept"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="15" fill="#048746" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M20.4134 10.6025C20.9084 11.015 20.9753 11.7506 20.5628 12.2456L14.9339 19.0003C14.3849 19.659 13.3888 19.7042 12.7824 19.0978L9.50821 15.8237C9.0526 15.3681 9.0526 14.6294 9.50821 14.1738C9.96382 13.7182 10.7025 13.7182 11.1581 14.1738L13.7548 16.7704L18.7702 10.7518C19.1827 10.2569 19.9184 10.19 20.4134 10.6025Z"
                      fill="white"
                    />
                  </svg>
                </button>

                <button
                  className="py-1.5 px-3 bg-primary text-white text-12 font-semibold rounded-md anim"
                  onClick={() => handleAllowEditWithRemark(row?._id)}
                  title="Allow Edit"
                >
                  <span>Allow Edit</span>
                </button>

                <button
                  className="flex items-center cursor-pointer space-x-2.5"
                  onClick={() => rejectRequest(row?._id)}
                  title="Reject"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="15" fill="#D21A0E" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.0917 10.0917C10.5473 9.6361 11.286 9.6361 11.7416 10.0917L19.9083 18.2584C20.3639 18.714 20.3639 19.4527 19.9083 19.9083C19.4527 20.3639 18.714 20.3639 18.2584 19.9083L10.0917 11.7416C9.6361 11.286 9.6361 10.5473 10.0917 10.0917Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M19.9083 10.0917C20.3639 10.5473 20.3639 11.286 19.9083 11.7416L11.7416 19.9083C11.286 20.3639 10.5473 20.3639 10.0917 19.9083C9.6361 19.4527 9.6361 18.714 10.0917 18.2584L18.2584 10.0917C18.714 9.6361 19.4527 9.6361 19.9083 10.0917Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </>
            )}

            {notificationType === "approved" && (
              <button
                className="py-1.5 px-3 bg-primary text-white text-12 font-semibold rounded-md anim"
                onClick={() => handleDistributeConfirm(row?._id)}
                title="Distribute"
              >
                <span>Distribute</span>
              </button>
            )}

            {notificationType === "rejected" && (
              row?.allowEdit ? (
                <span className="px-3 py-1 bg-green/10 text-green text-12 font-bold rounded border border-green/20">
                  Permission Given
                </span>
              ) : (
                <button
                  className="py-1.5 px-3 bg-primary text-white text-12 font-semibold rounded-md anim"
                  onClick={() => handleAllowEditConfirm(row?._id)}
                  title="Allow Edit"
                >
                  <span>Allow Edit</span>
                </button>
              )
            )}

            {notificationType === "approved" && row?.coupen ? (
              <button
                className="py-1.5 px-3 bg-red text-white text-12 font-semibold rounded-md anim"
                onClick={() => handleDownload(row)}
                title="Download"
              >
                <span>Download</span>
              </button>
            ) : null}

            {notificationType === "approved" && (
              <button
                className="flex items-center cursor-pointer space-x-2.5"
                onClick={() => rejectRequest(row?._id)}
                title="Reject"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="15" cy="15" r="15" fill="#D21A0E" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0917 10.0917C10.5473 9.6361 11.286 9.6361 11.7416 10.0917L19.9083 18.2584C20.3639 18.714 20.3639 19.4527 19.9083 19.9083C19.4527 20.3639 18.714 20.3639 18.2584 19.9083L10.0917 11.7416C9.6361 11.286 9.6361 10.5473 10.0917 10.0917Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9083 10.0917C20.3639 10.5473 20.3639 11.286 19.9083 11.7416L11.7416 19.9083C11.286 20.3639 10.5473 20.3639 10.0917 19.9083C9.6361 19.4527 9.6361 18.714 10.0917 18.2584L18.2584 10.0917C18.714 9.6361 19.4527 9.6361 19.9083 10.0917Z"
                    fill="white"
                  />
                </svg>
              </button>
            )}

            {notificationType === "rejected" && (
              <button
                className="flex items-center cursor-pointer space-x-2.5"
                onClick={() => handleAcceptConfirm(row?._id)}
                title="Accept"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="15" cy="15" r="15" fill="#048746" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.4134 10.6025C20.9084 11.015 20.9753 11.7506 20.5628 12.2456L14.9339 19.0003C14.3849 19.659 13.3888 19.7042 12.7824 19.0978L9.50821 15.8237C9.0526 15.3681 9.0526 14.6294 9.50821 14.1738C9.96382 13.7182 10.7025 13.7182 11.1581 14.1738L13.7548 16.7704L18.7702 10.7518C19.1827 10.2569 19.9184 10.19 20.4134 10.6025Z"
                    fill="white"
                  />
                </svg>
              </button>
            )}
          </div>
        );
      },
    },
  ].filter(Boolean);

  const acceptRequest = async (resultid) => {
    try {
      setLoading(true);
      await dispatch(
        approveRejectResult({
          resultId: resultid || "",
          action: "approved",
        }),
      ).unwrap();
      await getResultListFun();
      setLoading(false);
      toast.success("Result accepted successfully");
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
      toast.error("Failed to accept result");
    }
  };

  const distributeRequest = async (resultid) => {
    try {
      setLoading(true);
      await dispatch(
        approveRejectResult({
          resultId: resultid || "",
          action: "distributed",
        }),
      ).unwrap();
      await getResultListFun();
      setLoading(false);
      toast.success("Result distributed successfully");
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
      toast.error("Failed to distribute result");
    }
  };

  const allowEditRequest = async (resultid) => {
    try {
      setLoading(true);
      await dispatch(allowEditResult({ resultId: resultid })).unwrap();
      await getResultListFun();
      setLoading(false);
      toast.success("Edit permission allowed successfully");
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
      toast.error("Failed to allow edit permission");
    }
  };

  const handleDistributeConfirm = (resultid) => {
    setConfirmConfig({
      title: "Confirm Distribution",
      message: "સભ્ય નું ઇનામ વિતરણ થઈ ગયું છે ?",
      onConfirm: () => {
        distributeRequest(resultid);
        setIsConfirmModalOpen(false);
      },
    });
    setIsConfirmModalOpen(true);
  };

  const handleAllowEditConfirm = (resultid) => {
    setConfirmConfig({
      title: "Allow Edit",
      message: "શું તમે આ સભ્ય ને પરિણામ એડિટ કરવાની મંજૂરી આપવા માંગો છો ?",
      onConfirm: () => {
        allowEditRequest(resultid);
        setIsConfirmModalOpen(false);
      },
    });
    setIsConfirmModalOpen(true);
  };

  const handleAllowEditWithRemark = (resultid) => {
    setRejectId(resultid);
    setIsAllowEditRequest(true);
    setIsRejectModalOpen(true);
  };

  const handleAcceptConfirm = (resultid) => {
    setConfirmConfig({
      title: "Confirm Approval",
      message: "શું તમે આ પરિણામ ને સ્વીકારવા માંગો છો ?",
      onConfirm: () => {
        acceptRequest(resultid);
        setIsConfirmModalOpen(false);
      },
    });
    setIsConfirmModalOpen(true);
  };

  const rejectRequest = (resultid) => {
    setRejectId(resultid);
    setIsRejectModalOpen(true);
  };

  const handleRejectConfirm = async (remark) => {
    if (!rejectId) return;
    try {
      setLoading(true);
      
      if (isAllowEditRequest) {
        // Handle allow edit with remark scenario
        await dispatch(
          approveRejectResult({
            resultId: rejectId || "",
            remark: remark || "",
            action: "rejected",
          }),
        ).unwrap();
        
        // After rejecting with remark, also allow edit
        await dispatch(allowEditResult({ resultId: rejectId })).unwrap();
        
        toast.success("Result rejected and edit permission granted successfully");
      } else {
        // Handle regular reject scenario
        await dispatch(
          approveRejectResult({
            resultId: rejectId || "",
            remark: remark || "",
            action: "rejected",
          }),
        ).unwrap();
        
        toast.success("Result rejected successfully");
      }
      
      await getResultListFun();
      setIsRejectModalOpen(false);
      setRejectId(null);
      setIsAllowEditRequest(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
      toast.error("Failed to process request");
    }
  };

  const handleEditNotification = (row) => {
    // event.preventDefault();
    navigate(`edit-result-notification/${row._id}`, {
      state: { 
        isRejected: notificationType === "rejected",
        notificationType: notificationType
      },
    });
  };

  useEffect(() => {
    getVillage();
    getEducation();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => getVillage(villageSearch), 500);
    return () => clearTimeout(timer);
  }, [villageSearch]);

  useEffect(() => {
    const timer = setTimeout(() => getEducation(educationSearch), 500);
    return () => clearTimeout(timer);
  }, [educationSearch]);

  useEffect(() => {
    setTableData([]);
    getResultListFun();
  }, [notificationType, SelectedEducation, SelectedVillage, searchValue, selectedSeries]);

  const handleDownload = (row) => {
    if (row?.coupen) {
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = row?.coupen;
      a.target = "_blank";
      a.download = row?.coupen;
      a.click();
      window.URL.revokeObjectURL(row?.coupen);
      a.remove();
      // fetchUserData();
    }
  };

  const handleExportData = async () => {
    try {
      setLoading(true);
      const payload = {
        search: searchValue || "",
        type: notificationType || "",
        village: SelectedVillage || "",
        education: SelectedEducation || "",
        series: selectedSeries || "",
      };
      const response = await dispatch(resultExport(payload)).unwrap();
      if (response?.IsSuccess) {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = response.Data;
        a.target = "_self";
        a.download = response.Data;
        a.click();
        window.URL.revokeObjectURL(response.Data);
        a.remove();
        toast.success("Data exported successfully");
        setLoading(false);
        getResultListFun();
      }
    } catch (error) {
      toast.error("Failed to export data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="p-7">
        <div className="flex flex-wrap items-center my-auto">
          {/* Filter Section */}
          <div className="flex flex-wrap justify-end gap-4 mb-3 3xl:mb-0 w-full">
            <div className="md:flex flex-wrap items-center gap-4 ml-auto space-y-2.5 md:space-y-0">
              {/* <div className="relative">
                                <input
                                    onKeyUpCapture={(e) => setSearchValue(e.target.value)}
                                    type="text"
                                    placeholder="Search"
                                    className="w-full pl-10 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                                />
                                <span className="absolute left-3 top-2.5">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.125 1C4.63769 1 1 4.63769 1 9.125C1 13.6123 4.63769 17.25 9.125 17.25C13.6123 17.25 17.25 13.6123 17.25 9.125C17.25 4.63769 13.6123 1 9.125 1ZM2.25 9.125C2.25 5.32804 5.32804 2.25 9.125 2.25C12.922 2.25 16 5.32804 16 9.125C16 12.922 12.922 16 9.125 16C5.32804 16 2.25 12.922 2.25 9.125Z" fill="#8897AE" />
                                        <path d="M16.2337 15.3498C15.9896 15.1057 15.5939 15.1057 15.3498 15.3498C15.1057 15.5939 15.1057 15.9896 15.3498 16.2337L18.683 19.567C18.9271 19.8111 19.3228 19.8111 19.5669 19.567C19.811 19.3229 19.811 18.9272 19.5669 18.6831L16.2337 15.3498Z" fill="#8897AE" />
                                    </svg>
                                </span>
                            </div>
                            <div className="flex justify-between items-center mb-6">
                            <button onClick={() => handleExportData()} className="w-full md:w-auto flex items-center px-4 py-2 text-14 font-medium shadow-custom_shadow bg-white border rounded-md text-text_1 hover:bg-gray-50">
                                    <span className=" mr-2">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.01486 17.4487L5.89753 18.1895L5.89753 18.1895L6.01486 17.4487ZM2.5513 13.9851L3.29206 13.8678L2.5513 13.9851ZM17.4487 13.9851L18.1895 14.1025L18.1895 14.1025L17.4487 13.9851ZM13.9851 17.4487L14.1025 18.1895H14.1025L13.9851 17.4487ZM17.2666 8.71623C17.0179 8.38504 16.5477 8.31822 16.2165 8.56699C15.8853 8.81576 15.8185 9.28591 16.0673 9.6171L17.2666 8.71623ZM3.9327 9.6171C4.18147 9.28591 4.11465 8.81576 3.78346 8.56699C3.45227 8.31822 2.98212 8.38504 2.73335 8.71623L3.9327 9.6171ZM10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58579 1.75 9.25 2.08579 9.25 2.5H10.75ZM7.25435 10.3674C6.997 10.0428 6.52526 9.9883 6.2007 10.2456C5.87613 10.503 5.82163 10.9747 6.07898 11.2993L7.25435 10.3674ZM7.83154 12.3025L7.24385 12.7684L7.83154 12.3025ZM12.1685 12.3025L11.5808 11.8365L12.1685 12.3025ZM13.921 11.2993C14.1784 10.9747 14.1239 10.503 13.7993 10.2456C13.4747 9.9883 13.003 10.0428 12.7456 10.3674L13.921 11.2993ZM9.79111 14.1501L9.6731 14.8907H9.67311L9.79111 14.1501ZM10.2089 14.1501L10.3269 14.8907H10.3269L10.2089 14.1501ZM16.75 11.6667V12.5H18.25V11.6667H16.75ZM12.5 16.75H7.5V18.25H12.5V16.75ZM3.25 12.5V11.6667H1.75V12.5H3.25ZM7.5 16.75C6.69717 16.75 6.38307 16.7477 6.13218 16.7079L5.89753 18.1895C6.29441 18.2523 6.75449 18.25 7.5 18.25V16.75ZM1.75 12.5C1.75 13.2455 1.74767 13.7056 1.81053 14.1025L3.29206 13.8678C3.25233 13.6169 3.25 13.3028 3.25 12.5H1.75ZM6.13218 16.7079C4.67022 16.4764 3.52362 15.3298 3.29206 13.8678L1.81053 14.1025C2.14374 16.2063 3.79373 17.8563 5.89753 18.1895L6.13218 16.7079ZM16.75 12.5C16.75 13.3028 16.7477 13.6169 16.7079 13.8678L18.1895 14.1025C18.2523 13.7056 18.25 13.2455 18.25 12.5H16.75ZM12.5 18.25C13.2455 18.25 13.7056 18.2523 14.1025 18.1895L13.8678 16.7079C13.6169 16.7477 13.3028 16.75 12.5 16.75V18.25ZM16.7079 13.8678C16.4764 15.3298 15.3298 16.4764 13.8678 16.7079L14.1025 18.1895C16.2063 17.8563 17.8563 16.2063 18.1895 14.1025L16.7079 13.8678ZM18.25 11.6667C18.25 10.5607 17.8839 9.53804 17.2666 8.71623L16.0673 9.6171C16.4962 10.1881 16.75 10.8966 16.75 11.6667H18.25ZM3.25 11.6667C3.25 10.8966 3.50384 10.1881 3.9327 9.6171L2.73335 8.71623C2.11607 9.53804 1.75 10.5607 1.75 11.6667H3.25ZM9.25 2.5V13.3333H10.75V2.5H9.25ZM6.07898 11.2993L7.24385 12.7684L8.41922 11.8365L7.25435 10.3674L6.07898 11.2993ZM12.7561 12.7684L13.921 11.2993L12.7456 10.3674L11.5808 11.8365L12.7561 12.7684ZM7.24385 12.7684C7.69695 13.3399 8.07587 13.8196 8.41604 14.1611C8.75955 14.506 9.15655 14.8084 9.6731 14.8907L9.90912 13.4094C9.85955 13.4015 9.74124 13.366 9.47874 13.1025C9.21289 12.8356 8.89509 12.4367 8.41922 11.8365L7.24385 12.7684ZM11.5808 11.8365C11.1049 12.4367 10.7871 12.8356 10.5213 13.1025C10.2588 13.366 10.1405 13.4015 10.0909 13.4094L10.3269 14.8907C10.8435 14.8084 11.2405 14.506 11.584 14.1611C11.9241 13.8196 12.303 13.3399 12.7561 12.7684L11.5808 11.8365ZM9.67311 14.8907C9.78134 14.908 9.89057 14.9167 10 14.9167V13.4167C9.9699 13.4167 9.93959 13.4143 9.90912 13.4094L9.67311 14.8907ZM10 14.9167C10.1094 14.9167 10.2187 14.908 10.3269 14.8907L10.0909 13.4094C10.0604 13.4143 10.0301 13.4167 10 13.4167V14.9167ZM9.25 13.3333V14.1667H10.75V13.3333H9.25Z" fill="#2D3643" />
                                        </svg>
                                    </span>
                                    Download Report
                                </button>
                            </div> */}
              <div className="md:flex items-center justify-end gap-4 space-y-2 md:space-y-0">
                <div className="relative">
                  <input
                    onKeyUpCapture={(e) => setSearchValue(e.target.value)}
                    type="text"
                    placeholder="Search"
                    className="w-full pl-10 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                  />
                  <span className="absolute left-3 top-2.5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.125 1C4.63769 1 1 4.63769 1 9.125C1 13.6123 4.63769 17.25 9.125 17.25C13.6123 17.25 17.25 13.6123 17.25 9.125C17.25 4.63769 13.6123 1 9.125 1ZM2.25 9.125C2.25 5.32804 5.32804 2.25 9.125 2.25C12.922 2.25 16 5.32804 16 9.125C16 12.922 12.922 16 9.125 16C5.32804 16 2.25 12.922 2.25 9.125Z"
                        fill="#8897AE"
                      />
                      <path
                        d="M16.2337 15.3498C15.9896 15.1057 15.5939 15.1057 15.3498 15.3498C15.1057 15.5939 15.1057 15.9896 15.3498 16.2337L18.683 19.567C18.9271 19.8111 19.3228 19.8111 19.5669 19.567C19.811 19.3229 19.811 18.9272 19.5669 18.6831L16.2337 15.3498Z"
                        fill="#8897AE"
                      />
                    </svg>
                  </span>
                </div>
                <button
                  onClick={() => handleExportData()}
                  className="w-full md:w-[170px] flex items-center px-3 py-2 text-14 font-medium shadow-custom_shadow bg-white border rounded-md text-text_1 hover:bg-gray-50"
                >
                  <span className=" mr-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.01486 17.4487L5.89753 18.1895L5.89753 18.1895L6.01486 17.4487ZM2.5513 13.9851L3.29206 13.8678L2.5513 13.9851ZM17.4487 13.9851L18.1895 14.1025L18.1895 14.1025L17.4487 13.9851ZM13.9851 17.4487L14.1025 18.1895H14.1025L13.9851 17.4487ZM17.2666 8.71623C17.0179 8.38504 16.5477 8.31822 16.2165 8.56699C15.8853 8.81576 15.8185 9.28591 16.0673 9.6171L17.2666 8.71623ZM3.9327 9.6171C4.18147 9.28591 4.11465 8.81576 3.78346 8.56699C3.45227 8.31822 2.98212 8.38504 2.73335 8.71623L3.9327 9.6171ZM10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58579 1.75 9.25 2.08579 9.25 2.5H10.75ZM7.25435 10.3674C6.997 10.0428 6.52526 9.9883 6.2007 10.2456C5.87613 10.503 5.82163 10.9747 6.07898 11.2993L7.25435 10.3674ZM7.83154 12.3025L7.24385 12.7684L7.83154 12.3025ZM12.1685 12.3025L11.5808 11.8365L12.1685 12.3025ZM13.921 11.2993C14.1784 10.9747 14.1239 10.503 13.7993 10.2456C13.4747 9.9883 13.003 10.0428 12.7456 10.3674L13.921 11.2993ZM9.79111 14.1501L9.6731 14.8907H9.67311L9.79111 14.1501ZM10.2089 14.1501L10.3269 14.8907H10.3269L10.2089 14.1501ZM16.75 11.6667V12.5H18.25V11.6667H16.75ZM12.5 16.75H7.5V18.25H12.5V16.75ZM3.25 12.5V11.6667H1.75V12.5H3.25ZM7.5 16.75C6.69717 16.75 6.38307 16.7477 6.13218 16.7079L5.89753 18.1895C6.29441 18.2523 6.75449 18.25 7.5 18.25V16.75ZM1.75 12.5C1.75 13.2455 1.74767 13.7056 1.81053 14.1025L3.29206 13.8678C3.25233 13.6169 3.25 13.3028 3.25 12.5H1.75ZM6.13218 16.7079C4.67022 16.4764 3.52362 15.3298 3.29206 13.8678L1.81053 14.1025C2.14374 16.2063 3.79373 17.8563 5.89753 18.1895L6.13218 16.7079ZM16.75 12.5C16.75 13.3028 16.7477 13.6169 16.7079 13.8678L18.1895 14.1025C18.2523 13.7056 18.25 13.2455 18.25 12.5H16.75ZM12.5 18.25C13.2455 18.25 13.7056 18.2523 14.1025 18.1895L13.8678 16.7079C13.6169 16.7477 13.3028 16.75 12.5 16.75V18.25ZM16.7079 13.8678C16.4764 15.3298 15.3298 16.4764 13.8678 16.7079L14.1025 18.1895C16.2063 17.8563 17.8563 16.2063 18.1895 14.1025L16.7079 13.8678ZM18.25 11.6667C18.25 10.5607 17.8839 9.53804 17.2666 8.71623L16.0673 9.6171C16.4962 10.1881 16.75 10.8966 16.75 11.6667H18.25ZM3.25 11.6667C3.25 10.8966 3.50384 10.1881 3.9327 9.6171L2.73335 8.71623C2.11607 9.53804 1.75 10.5607 1.75 11.6667H3.25ZM9.25 2.5V13.3333H10.75V2.5H9.25ZM6.07898 11.2993L7.24385 12.7684L8.41922 11.8365L7.25435 10.3674L6.07898 11.2993ZM12.7561 12.7684L13.921 11.2993L12.7456 10.3674L11.5808 11.8365L12.7561 12.7684ZM7.24385 12.7684C7.69695 13.3399 8.07587 13.8196 8.41604 14.1611C8.75955 14.506 9.15655 14.8084 9.6731 14.8907L9.90912 13.4094C9.85955 13.4015 9.74124 13.366 9.47874 13.1025C9.21289 12.8356 8.89509 12.4367 8.41922 11.8365L7.24385 12.7684ZM11.5808 11.8365C11.1049 12.4367 10.7871 12.8356 10.5213 13.1025C10.2588 13.366 10.1405 13.4015 10.0909 13.4094L10.3269 14.8907C10.8435 14.8084 11.2405 14.506 11.584 14.1611C11.9241 13.8196 12.303 13.3399 12.7561 12.7684L11.5808 11.8365ZM9.67311 14.8907C9.78134 14.908 9.89057 14.9167 10 14.9167V13.4167C9.9699 13.4167 9.93959 13.4143 9.90912 13.4094L9.67311 14.8907ZM10 14.9167C10.1094 14.9167 10.2187 14.908 10.3269 14.8907L10.0909 13.4094C10.0604 13.4143 10.0301 13.4167 10 13.4167V14.9167ZM9.25 13.3333V14.1667H10.75V13.3333H9.25Z"
                        fill="#2D3643"
                      />
                    </svg>
                  </span>
                  Download Report
                </button>
                <select
                  value={selectedSeries}
                  onChange={(e) => setSelectedSeries(e.target.value)}
                  className="w-full md:w-auto px-4 py-2.5 border rounded-md bg-white text-gray_2 focus:outline-none shadow-custom_shadow"
                >
                  <option value="">Select Series</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
                <Select
                  id="villageId"
                  name="villageId"
                  filterOption={() => true}
                  inputValue={villageSearch}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") setVillageSearch(inputValue);
                  }}
                  onBlur={() => setVillageSearch("")}
                  options={villages.map((item) => ({
                    value: item?._id,
                    label: item?.gujarati_name,
                  }))}
                  value={
                    villages
                      .filter((v) => v._id === SelectedVillage)
                      .map((item) => ({
                        value: item?._id,
                        label: item?.gujarati_name,
                      }))[0] || null
                  }
                  onChange={(selected) => {
                    setVillageSearch("");
                    setSelectedVillage(selected ? selected.value : "");
                  }}
                  placeholder="સભ્યના ગામનું નામ"
                  classNamePrefix="react-select"
                  className="w-full md:w-56"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: '42px',
                      borderRadius: '0.375rem',
                      borderColor: '#D1D5DB',
                      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                    })
                  }}
                  isClearable
                />
                <Select
                  id="educationId"
                  name="educationId"
                  filterOption={() => true}
                  inputValue={educationSearch}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") setEducationSearch(inputValue);
                  }}
                  onBlur={() => setEducationSearch("")}
                  options={educations.map((item) => ({
                    value: item?._id,
                    label: item?.gujarati_name,
                  }))}
                  value={
                    educations
                      .filter((e) => e._id === SelectedEducation)
                      .map((item) => ({
                        value: item?._id,
                        label: item?.gujarati_name,
                      }))[0] || null
                  }
                  onChange={(selected) => {
                    setEducationSearch("");
                    setSelectedEducation(selected ? selected.value : "");
                  }}
                  placeholder="સભ્યનું એજ્યુકેશન"
                  classNamePrefix="react-select"
                  className="w-full md:w-56"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: '42px',
                      borderRadius: '0.375rem',
                      borderColor: '#D1D5DB',
                      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                    })
                  }}
                  isClearable
                />
                <button
                  className="w-full max-w-[120px] btn flex justify-center items-center space-x-1"
                  onClick={() => handleClearFilter()}
                >
                  <span className="icon-plus text-[20px] font-extrabold"></span>
                  <span>Clear Filter</span>
                </button>
              </div>
            </div>
          </div>
          <RejectModal
            isOpen={isRejectModalOpen}
            onClose={() => setIsRejectModalOpen(false)}
            onConfirm={handleRejectConfirm}
            loading={loading}
          />
          <ConfirmModal
            isOpen={isConfirmModalOpen}
            onClose={() => setIsConfirmModalOpen(false)}
            title={confirmConfig.title}
            message={confirmConfig.message}
            onConfirm={confirmConfig.onConfirm}
            loading={loading}
          />
          <div className="flex flex-wrap xs:space-x-3.5 lg:space-x-6 border-b">
            <button
              onClick={() => {
                setNotificationType("pending");
              }}
              className={`py-1.5 xl:py-2.5 px-3 xl:px-5 text-16 md:text-18 font-semibold anim ${notificationType === "pending"
                ? "text-primary border-b-2 border-primary"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Pending Result
            </button>
            <button
              onClick={() => {
                setNotificationType("approved");
              }}
              className={`py-1.5 xl:py-2.5 px-3 xl:px-5 text-16 md:text-18 font-semibold anim ${notificationType === "approved"
                ? "text-primary border-b-2 border-primary"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Accepted Result
            </button>
            <button
              onClick={() => {
                setNotificationType("rejected");
              }}
              className={`py-1.5 xl:py-2.5 px-3 xl:px-5 text-16 md:text-18 font-semibold anim ${notificationType === "rejected"
                ? "text-primary border-b-2 border-primary"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Rejected Result
            </button>
            <button
              onClick={() => {
                setNotificationType("distributed");
              }}
              className={`py-1.5 xl:py-2.5 px-3 xl:px-5 text-16 md:text-18 font-semibold anim ${notificationType === "distributed"
                ? "text-primary border-b-2 border-primary"
                : "text-gray-500 hover:text-gray-700"
                }`}
            >
              Distributed Result
            </button>
          </div>
        </div>
        {/* Table Section */}
        <CustomTable
          columns={columns}
          data={tableData}
          isPagination={true}
          totalRecords={paginationData}
          loading={loading}
          handlePageChange={handlePageChange}
          currentPage={paginationState.page}
          pageSize={paginationState.limit}
        />
      </div>
    </>
  );
};

export default ResultNotification;
